/**
 * useStaffApi — gibt eine memoisierte StaffApi-Instance zurück, die mit
 * dem aktuellen Keycloak-Token (aus useAuth) gegen admin-api auf
 * api.it-sce.de spricht.
 *
 * TQ #9695/#9696 (Staff-Migration Teil B+C, Bundle #9523). Portiert aus
 * customer-portal/src/hooks/useStaffApi.ts — Pages aus pages/staff/ nutzen
 * diesen Hook fuer alle Aufrufe, die bereits einen typed StaffApi-Baustein
 * in @it-sce/ui haben (z.B. services, subscriptionPlans, tokens), statt
 * direkt services/api.ts staff*-Methoden.
 *
 * Beispiel:
 *   const staff = useStaffApi()
 *   const { data, loading, error, refetch } = useApiResource(
 *     ['staff-services'],
 *     () => staff.services.list()
 *   )
 */

import { useMemo, useRef } from 'react'
import { useAuth } from '@it-sce/ui/contexts/KeycloakAuthContext'
import type { StaffApi } from '@it-sce/ui'
import { buildStaffApi } from '../services/staffApi'

export function useStaffApi(): StaffApi {
  const { token } = useAuth()
  const tokenRef = useRef<string | null>(token)
  tokenRef.current = token

  // Build StaffApi once. The interceptor reads tokenRef.current on every
  // request, so token refreshes propagate automatically.
  return useMemo(
    () => buildStaffApi(() => tokenRef.current),
    []
  )
}
